/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  editFieldForceAccount,
  getSpecificFieldForceAccount,
  resetEditFieldForceAccount,
} from "../../../../../redux/features/accounts/fieldForceAccount";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import Validation from "../../../../../utils/validation";
import SmallPopup from "../../../../../components/_utils/CommonSmallPopup";
import PrimaryStepper from "../../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import CommonLayout from "../../../../../components/_utils/CommonLayout";
import ContactDetails from "../../../../../components/_utils/AccountCreationComponents/ContactDetails";
import AccountName from "../../../../../components/_utils/AccountCreationComponents/AccountName";
import CommonDestinationAccount from "../../../../../components/_utils/TransactionCommonComponents/CommonDestinationAccount";
import LargePopupRedirect from "../../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import UsersSettings from "../../../../Settings/Users";

const FieldForceAccountEditContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [customErrors, setCustomErrors] = useState({});
  const [selectedValue, setSelectedValue] = useState("");
  const [emailValidation, setEmailValidation] = useState(false);
  const [nextButtonEnabled, setNextButtonEnabled] = useState(true);
  const [openEditContactPop, setOpenEditContactPop] = useState(false);
  const [accountNameValidation, setAccountNameValidation] = useState(true);
  const [contactNumberValidation, setContactNumberValidation] = useState(false);
  const [cancelBut, setCanclebtn] = useState(false);
  const [selectedRadioValue, setSelectedRadioValue] = useState("customname");
  const [payload, setPayload] = useState({
    contact_no: "",
    email_id: "",
    account_name: "",
    legalName: "",
    userName: "", // Get from get specific API
    bankAccountName: "",
    linked_user_id: "",
    userId: "",
    amount: "",
  });

  const [isUserPopupOpen, setIsUserPopupOpen] = useState(false);

  const normalizeLimitValue = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const parsed = Number(String(value).replace(/,/g, ""));
    return Number.isNaN(parsed) ? String(value) : parsed;
  };

  const resolveLinkedUserId = (accountData) =>
    String(
      accountData?.linked_user_id || accountData?.field_force_user_id || "",
    );
  const normalizeAccountName = (name) => (name || "").trim().toLowerCase();

  const resolveAccountNameSource = (accountData) => {
    const accountName = normalizeAccountName(accountData?.name);
    const legalName = normalizeAccountName(accountData?.pan_legal_name);
    const linkedUserName = normalizeAccountName(
      accountData?.field_force_user_full_name,
    );
    const bankAccountName = normalizeAccountName(
      accountData?.bank_account_holder_full_name,
    );

    if (accountName && accountName === legalName) {
      return "legalname";
    }
    if (accountName && linkedUserName && accountName === linkedUserName) {
      return "username";
    }
    if (accountName && bankAccountName && accountName === bankAccountName) {
      return "bankaccountname";
    }
    return "customname";
  };

  const {
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    editFieldForceAccountData,
  } = useSelector((state) => state.fieldForceAccount);
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  useEffect(() => {
    const fetchContactData = async () => {
      let response = await dispatch(getSpecificFieldForceAccount({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchContactData();
  }, [dispatch, id, navigate]);

  const handleBack = () => {
    if (!nextButtonEnabled) {
      setOpenEditContactPop(true);
    } else {
      navigate(-1);
    }
  };

  const handleRadioBtn = (event) => {
    setSelectedValue(event.target.value);
    setSelectedRadioValue(event.target.value);
    handleUpdateLegalName(event.target.value);
  };
  const handleDivBtn = (value) => {
    setSelectedValue(value);
    setSelectedRadioValue(value);
    handleUpdateLegalName(value);
  };

  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      getSpecificFieldForceAccountData?.status === true
    ) {
      const fieldForceData =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];

      if (fieldForceData) {
        const resolvedLimit =
          fieldForceData.field_force_custom_limit ??
          GlobalConfiguration.defaultAmount;

        setPayload((prevPayload) => ({
          ...prevPayload,
          contact_no: fieldForceData.contact_no,
          email_id: fieldForceData.email_id,
          account_name: fieldForceData.name || "",
          legalName: fieldForceData.pan_legal_name,
          userName: fieldForceData.field_force_user_full_name || "",
          bankAccountName:
            fieldForceData.bank_account_holder_full_name ||
            fieldForceData.name ||
            "",
          userId: fieldForceData.field_force_identifier || "",
          linked_user_id: resolveLinkedUserId(fieldForceData),
          amount: resolvedLimit,
        }));
      }
      const accountNameSource = resolveAccountNameSource(fieldForceData);
      setSelectedValue(accountNameSource);
      setSelectedRadioValue(accountNameSource);
    }
  }, [
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    dispatch,
  ]);

  useEffect(() => {
    setContactNumberValidation(
      Validation.allowedContactNum(payload.contact_no),
    );
    setEmailValidation(Validation.allowedEmail(payload.email_id));
  }, [payload.contact_no, payload.email_id]);

  const emailRegex = Validation.emailRegex;

  const modifyValue = (type, value) => {
    if (type === "name") {
      return value?.replace(/(\w)(\w*)/g, function (g1, g2) {
        return g1.toUpperCase() + g2.toLowerCase();
      });
    } else if (type === "gstin") {
      return value?.toUpperCase();
    } else if (type === "account_name") {
      return value;
    } else {
      return value.trim();
    }
  };

  const allowedValue = (name, value) => {
    if (name === "contact_no") return Validation.allowedContactNum(value);
    if (name === "email_id") return Validation.allowedEmail(value);

    return true;
  };

  const validateAndRecordError = (name, value) => {
    let errors = { ...customErrors };
    if (name === "email_id")
      errors = Validation.validateEmail(name, value, errors);
    if (name === "contact_no")
      errors = Validation.validateContactNum(name, value, errors);
    if (name === "account_name")
      errors = Validation.validateAccountName(name, value, errors);
    setCustomErrors(errors);
  };

  const checkAllValidations = () => {
    return contactNumberValidation && emailValidation;
  };

  const handleUpdateLegalName = (value) => {
    const beneficiaryData =
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];

    setPayload((prevPayload) => {
      if (value === "legalname") {
        return {
          ...prevPayload,
          account_name: beneficiaryData?.pan_legal_name || "",
        };
      }

      if (value === "username") {
        return {
          ...prevPayload,
          account_name: payload.userName,
        };
      }

      if (value === "bankaccountname") {
        return {
          ...prevPayload,
          account_name: payload.bankAccountName,
        };
      }

      if (value === "customname") {
        const keepCurrent =
          prevPayload.account_name &&
          prevPayload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero &&
          prevPayload.account_name.trim().toLowerCase() !==
            (beneficiaryData?.pan_legal_name || "").trim().toLowerCase() &&
          prevPayload.account_name.trim().toLowerCase() !==
            (payload.userName || "").trim().toLowerCase() &&
          prevPayload.account_name.trim().toLowerCase() !==
            (payload.bankAccountName || "").trim().toLowerCase();

        return {
          ...prevPayload,
          account_name: keepCurrent
            ? prevPayload.account_name
            : beneficiaryData?.name || "",
        };
      }

      return prevPayload;
    });
  };

  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      getSpecificFieldForceAccountData?.status === true
    ) {
      const hasLinkedUser = Boolean(
        String(payload?.linked_user_id ?? "").trim(),
      );
      if (!hasLinkedUser) {
        setNextButtonEnabled(true);
        return;
      }

      if (
        selectedValue === "customname" &&
        payload.account_name.trim().length < 3
      ) {
        setNextButtonEnabled(true);
        return;
      }

      const beneficiaryData =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const linkedUserChanged =
        resolveLinkedUserId(beneficiaryData) !==
        resolveLinkedUserId({ linked_user_id: payload?.linked_user_id });
      const txnLimitChanged =
        normalizeLimitValue(
          beneficiaryData?.field_force_custom_limit ??
            GlobalConfiguration.defaultAmount,
        ) !==
        normalizeLimitValue(
          payload?.amount ?? GlobalConfiguration.defaultAmount,
        );
      const contactEmailChanged =
        beneficiaryData?.contact_no !== payload.contact_no ||
        (beneficiaryData?.email_id || "").toLowerCase() !==
          (payload.email_id || "").toLowerCase();
      const nameChanged =
        (beneficiaryData?.name || "").trim() !==
          (payload.account_name || "").trim() &&
        payload.account_name.length !== GlobalConfiguration.lengthCheckZero;
      const hasChanges =
        contactEmailChanged ||
        nameChanged ||
        linkedUserChanged ||
        txnLimitChanged;

      if (hasChanges) {
        if (
          (linkedUserChanged && !contactEmailChanged) ||
          nameChanged ||
          txnLimitChanged
        ) {
          setNextButtonEnabled(false);
        } else if (
          checkAllValidations() &&
          payload.email_id?.length !== GlobalConfiguration.lengthCheckZero &&
          payload.contact_no?.length !== GlobalConfiguration.lengthCheckZero &&
          payload.account_name.trim().length >
            GlobalConfiguration.lengthCheckZero
        ) {
          setNextButtonEnabled(false);
        } else {
          setNextButtonEnabled(true);
        }
      } else {
        setNextButtonEnabled(true);
      }
    }
  }, [
    payload.account_name,
    payload.contact_no,
    payload.email_id,
    payload.linked_user_id,
    payload.amount,
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    selectedValue,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = modifyValue(
      name,
      name !== "account_name" ? value.replace(/[^a-zA-Z0-9@.]/g, "") : value,
    );

    if (allowedValue(name, value)) {
      validateAndRecordError(name, newValue);
      setPayload((prevState) => ({
        ...prevState,
        [name]: newValue,
      }));

      if (
        value.trim() === "" &&
        value.length === GlobalConfiguration.lengthCheckOne
      ) {
        return;
      }
      if (name === "contact_no") {
        if (
          name === "contact_no" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            newValue.length < GlobalConfiguration.panLength)
        ) {
          setContactNumberValidation(false);
        } else {
          setContactNumberValidation(true);
        }
      }
      if (name === "email_id") {
        if (
          name === "email_id" &&
          (newValue.length === GlobalConfiguration.lengthCheckZero ||
            !emailRegex.test(newValue))
        ) {
          setEmailValidation(false);
        } else {
          setEmailValidation(true);
        }
      }
      if (name === "account_name") {
        if (
          name === "account_name" &&
          newValue.length === GlobalConfiguration.lengthCheckZero
        ) {
          setAccountNameValidation(false);
        } else {
          setAccountNameValidation(true);
        }
        const fieldForceAccount =
          getSpecificFieldForceAccountData?.field_force_accounts?.[
            GlobalConfiguration.lengthCheckZero
          ];
        const typedNameSource = resolveAccountNameSource({
          ...fieldForceAccount,
          bank_account_holder_full_name: payload.bankAccountName,
          name: newValue,
        });
        setSelectedValue(typedNameSource);
        setSelectedRadioValue(typedNameSource);
      }
    }
  };

  useEffect(() => {
    if (customErrors["contact_no"]) setContactNumberValidation(false);
    if (
      !customErrors["contact_no"] &&
      payload.contact_no?.length === GlobalConfiguration.panLength
    )
      setContactNumberValidation(true);
    if (customErrors["email_id"]) setEmailValidation(false);
    if (
      !customErrors["email_id"] &&
      payload.email_id?.length > GlobalConfiguration.lengthCheckZero &&
      emailRegex.test(payload.email_id)
    )
      setEmailValidation(true);
    if (customErrors["account_name"]) setAccountNameValidation(false);
    if (
      !customErrors["account_name"] &&
      payload.account_name.length > GlobalConfiguration.lengthCheckZero
    )
      setAccountNameValidation(true);
  }, [customErrors]);

  useEffect(() => {
    if (editFieldForceAccountData?.status === true) {
      const fieldForceData =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];
      const updatedFields = [];
      if (fieldForceData?.contact_no !== payload.contact_no) {
        updatedFields.push("contact_no");
      }
      if (
        (fieldForceData?.email_id || "").toLowerCase().trim() !==
        (payload.email_id || "").toLowerCase().trim()
      ) {
        updatedFields.push("email_id");
      }
      if (
        (fieldForceData?.name || "").trim() !==
        (payload.account_name || "").trim()
      ) {
        updatedFields.push("account_name");
      }
      if (
        String(
          fieldForceData?.field_force_user_id ||
            fieldForceData?.linked_user_id ||
            "",
        ) !== String(payload?.linked_user_id || "")
      ) {
        updatedFields.push("linked_user");
      }
      if (
        normalizeLimitValue(
          fieldForceData?.field_force_custom_limit ??
            GlobalConfiguration.defaultAmount,
        ) !==
        normalizeLimitValue(
          payload?.amount ?? GlobalConfiguration.defaultAmount,
        )
      ) {
        updatedFields.push("transaction_limit");
      }
      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/account_details_success/${id}`,
        {
          state: {
            updatedFields:
              updatedFields.length > GlobalConfiguration.lengthCheckZero
                ? updatedFields
                : [
                    "contact_no",
                    "email_id",
                    "account_name",
                    "linked_user",
                    "transaction_limit",
                  ],
          },
          replace: true,
        },
      );
      dispatch(resetEditFieldForceAccount());
    }
  }, [editFieldForceAccountData]);

  useEffect(() => {}, []);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("FFUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Update",
      stepperText: "User and contact details",
      previousEnableBgColor: "var(--primary-nav-act)",
      previousDisableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      nextDisableBgColor: !cancelBut && "var(--text-disabled)",
      nextIsEnabled: !nextButtonEnabled,
      nextHoverOption: "black",
      nextIsLoading: cancelBut ? true : false,
      nextLoaderNeeded: true,
    },
  ];

  const handleUpdateAccount2 = () => {
    if (!String(payload?.linked_user_id ?? "").trim()) return;
    const fieldForceData =
      getSpecificFieldForceAccountData?.field_force_accounts?.[
        GlobalConfiguration.lengthCheckZero
      ];
    const resolvedAccountName =
      (payload?.account_name || "").trim() ||
      (fieldForceData?.name || "").trim() ||
      (payload?.legalName || "").trim() ||
      (payload?.userName || "").trim();

    setCanclebtn(true);

    setTimeout(() => {
      dispatch(
        editFieldForceAccount({
          id: id,
          email: payload?.email_id,
          contact_no: payload.contact_no,
          name: resolvedAccountName,
          linked_user_id: payload?.linked_user_id || null,
          field_force_custom_limit: payload?.amount || null,
          navigate,
        }),
      );
      setCanclebtn(false);
      setNextButtonEnabled(true);
    }, 1000);
  };

  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };

  return (
    <>
      <div className=" bg-primary-bg flex overflow-y-hidden flex-col h-full-height">
        <div className="h-navbar-breadcrumb-height hidden Qmd:block"></div>
        <div
          className="max-w-tab-width-normal  w-full flex flex-col justify-start items-center mx-auto my-margin-base Qsmd:h-stepper-moble-height"
          style={{
            overflow: !nextButtonEnabled && openEditContactPop ? "hidden" : "",
          }}
        >
          {isUserPopupOpen && (
            <LargePopupRedirect
              headerTitle="User view all"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconhandleFunction={() => setIsUserPopupOpen(false)}
              isfullViewrequired={false}
              fullviewhandleFunction={() => navigate("/settings/user_view_all")}
              isscrollRequired={true}
            >
              <UsersSettings
                type="popup"
                setIsPopUpOpen={setIsUserPopupOpen}
                setPayload={setPayload}
                selectedValueUser={selectedValue}
                flow="edit"
              />
            </LargePopupRedirect>
          )}
          {!nextButtonEnabled && openEditContactPop && (
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <SmallPopup
                headerTitle={"Confirm leaving this page?"}
                headerFontWeight="semibold"
                headerFontColor="text-primary"
                textSize="font-md"
                subtext="Leaving this page will not update the changes made."
                btnOneText="Stay"
                btnOneBtnType="button"
                btnOneEnabledBgColor="transparent"
                btnOneHandleFunction={() => setOpenEditContactPop(false)}
                btnOneOutLineColor="var(--text-primary)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneIsDisabled={false}
                btnOneHoverOption="white"
                btnTwoText="Leave"
                btnTwoBtnType="button"
                btnTwoHandleFunction={handleConfirm}
                btnTwoEnabledBgColor="var(--negative-act)"
                btnTwoEnabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={false}
                btnTwoHoverOption="black"
              />
            </div>
          )}
          <div className="min-h-stepper-height Qsmd:relative h-auto flex justify-center items-end bottom-bottom-base Qsmd:flex fixed Qmd:top-top-base left-left-base w-width-full z-z-index-header">
            <PrimaryStepper
              activeStep={GlobalConfiguration.lengthCheckZero}
              handleForwardAction={handleUpdateAccount2}
              handleBackwardAction={handleBack}
              dataArray={dataArray}
            />
          </div>
          <div className=" bg-primary-nav mt-margin-base fixed top-top-base left-left-base w-full z-z-index-header">
            <TopNavComponent
              isFormattingNotRequired
              topNavHeader={"Field force account"}
              topNavSubText="Account details"
              handleBack={handleBack}
            />
          </div>

          <div className="h-navbar-height block Qmd:hidden"></div>
        </div>

        <div className="h-full-height  w-full px-padding-md Qlg:px-padding-base overflow-y-auto pt-padding-md flex-1 pb-[var(--stepper-moble-height)]">
          <div className="max-w-tab-width-normal mx-auto">
            <CommonLayout>
              <div className="flex flex-col relative rounded-border-radius-md w-full mb-margin-md  gap-gap-md">
                <CommonDestinationAccount
                  variant="user"
                  isOptional={false}
                  transactionPayload={payload}
                  setTransactionPayload={setPayload}
                  onSelectAccount={() => setIsUserPopupOpen(true)}
                  onDeleteAccount={() => {
                    const wasUsername = selectedValue === "username";
                    setPayload((prev) => ({
                      ...prev,
                      linked_user_id: "",
                      ...(wasUsername && {
                        account_name: prev.legalName || "",
                      }),
                    }));
                    if (wasUsername) {
                      setSelectedValue("legalname");
                      setSelectedRadioValue("legalname");
                    }
                  }}
                />
                <ContactDetails
                  handleChange={handleChange}
                  contactNumberValidation={contactNumberValidation}
                  emailValidation={emailValidation}
                  contactNumber={payload.contact_no}
                  emailId={payload.email_id}
                  selectedValue={selectedValue}
                />
              </div>

              <div className="flex flex-col relative rounded-border-radius-md w-full mb-margin-md  gap-gap-md">
                <AccountName
                  handleChange={handleChange}
                  accountNameValidation={accountNameValidation}
                  accountName={payload.account_name}
                  selectedValue={selectedValue}
                  handleDivBtn={handleDivBtn}
                  handleRadioBtn={handleRadioBtn}
                  selectedRadioValue={selectedRadioValue}
                  legalName={payload?.legalName}
                  type={"user"}
                  userName={payload.userName}
                  bankAccountName={payload.bankAccountName}
                  placeHolder={"Account name"}
                />
              </div>
            </CommonLayout>
          </div>
        </div>
      </div>
    </>
  );
};

export default FieldForceAccountEditContact;
